import React from 'react';
import sanitize from 'sanitize.css';
import { Global, css } from '@emotion/react';
import { themes } from 'config/branding/themes';
import { breakpoints } from 'config/breakpoints';
import styles from './styles.css';

const themeName = 'light'; // @TODO Fetch from redux if user wants to change theme through cms.
const theme = themes[themeName];

/**
 * The filtering below is to ensure that we only extract theme prefixed values.
 */
const lightStatics = themes.light.statics;
const orangePrefixed = Object.fromEntries(
    Object.entries(themes.orange.statics).filter(([key]) => key.startsWith('--orange--')),
);
const darkPrefixed = Object.fromEntries(
    Object.entries(themes.dark.statics).filter(([key]) => key.startsWith('--dark--')),
);
const allStatics = { ...lightStatics, ...orangePrefixed, ...darkPrefixed };

const Styles = () => (
    <Global
        styles={css`
            :root {
                --current-breakpoint: '${breakpoints[0].label}';
                ${Object.entries(allStatics)
                    .map(([key, value]) => `${key}: ${value};`)
                    .join('')}
            }

            ${breakpoints.map(
                (breakpoint) => `
        @media screen and (min-width: ${breakpoint.from}) {
            :root {
                --current-breakpoint: '${breakpoint.label}';
                ${Object.entries(theme.responsives[breakpoint.label])
                    .map(([key, value]) => `${key}: ${value};`)
                    .join('')}
            }
        }
    `,
            )}

            ${sanitize}
    ${styles}
        `}
    />
);

export default Styles;
